var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { contrast as _contrast, desaturate, mix, parseToColorString, parseToRgb } from "../utils/color.js";
import mapObjectValues from "../utils/map-object-values.js";
export const variantKeys = [25, 50, 100, 200, 300, 400, 500, 600];
const transparent = Object.fromEntries(variantKeys.map(k => [k, "transparent"]));
function createColorVariants(theme, color) {
    const desaturated = (color) => mix(theme.colors.background, desaturate(color, theme.scheme === "light" ? 0.3 : 0.15), 0.6);
    if (parseToRgb(color).alpha === 0)
        return transparent;
    return {
        25: mix(theme.colors.background, color, theme.scheme === "light" ? 0.03 : 0.075),
        50: mix(theme.colors.background, color, 0.1),
        100: mix(theme.colors.background, color, 0.15),
        200: mix(theme.colors.background, color, 0.3),
        300: desaturated(color),
        400: mix(theme.colors.background, color, 0.85),
        500: color,
        600: mix(theme.colors.text, color, 0.85),
    };
}
export function getColor(theme, color) {
    if (color in theme.colors) {
        return theme.colors[color];
    }
    else if (/^[a-z]+-\d+$/.test(color)) {
        const [base, variant] = color.split("-");
        return createColorVariants(theme, theme.colors[base] || base)[+variant];
    }
    return parseToColorString(color);
}
export function createCurrentPalette(theme, color) {
    color = getColor(theme, color);
    const current = createColorVariants(theme, color);
    const contrast = mapObjectValues(current, c => (c === "transparent" ? getColor(theme, "text") : _contrast(c)));
    return Object.assign(Object.assign({}, current), { contrast });
}
export default function createBasePalette(theme) {
    const _a = theme.colors, { background } = _a, colors = __rest(_a, ["background"]);
    return Object.assign({ background }, mapObjectValues(colors, color => createColorVariants(theme, color)));
}
//# sourceMappingURL=base.js.map